/**
 * Detects when the user's cart is updated
 * @param callback callback function that takes a MiniCartDetails as a parameter
 */
export default function (callback) {
    $(window).on('cartBannerUpdated', function () {
        /* global getMiniCartDetailsFromLocalStorageData */ // From general.js
        // noinspection JSValidateTypes
        callback(getMiniCartDetailsFromLocalStorageData());
    });
}
